(ns app.front.view.property.gis-import.update-session
  (:require [app.domain.municipality.model :as municipality-model]
            [app.domain.property.model :as property-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.view.property.dashboard.subs :as property-dashboard-subs]
            [app.front.view.property.gis-import.session-common :as gis-import-common]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-event-fx ::start-property-attribute-update
  (fn [_ [_ session-id]]
    {:fx [[:dispatch [:comm/command-monitored
                      {:command    :property-import/start-property-attribute-update
                       :data       (util/mmap session-id)
                       :on-success [::entities/apply-changes]
                       :notify     {:success :data-import/import-started}}]]]}))

(rf/reg-event-fx ::start-property-update
  (fn [_ [_ session-id]]
    {:fx [[:dispatch [:comm/command-monitored
                      {:command    :property-import/start-property-update
                       :data       (util/mmap session-id)
                       :on-success [::entities/apply-changes]
                       :notify     {:success :data-import/import-started}}]]]}))

(rf/reg-sub ::any-job-running?
  :<- [::gis-import-common/async-jobs]
  :<- [:comm/command-processing? :property-import/start-property-import]
  (fn [[jobs cmd-running?] _]
    (boolean (or cmd-running?
                 (some (du/in-state-fn :async-job.state/running) jobs)))))


(rf/reg-sub ::back-href
  (fn [_]
    (href/href :view/property-gis-update)))


(rf/reg-sub ::view-data
  :<- [::back-href]
  (fn [back-href]
    {:back-href back-href}))


(defn view [{{{:keys [session-id]} :path} :parameters :as match}]
  (when-let [session (<sub [::gis-import-common/session])]
    (let [tr              (<sub [::gis-import-common/property-tr])
          lang            (<sub [:language])
          format-date     (<sub [::date-util/date-time-fn])
          temp-records    (<sub [::property-dashboard-subs/import-temp-records session-id])
          async-jobs      (<sub [::gis-import-common/async-jobs])
          job-running?    (<sub [::any-job-running?])
          start-disabled? (or job-running?
                              (empty? temp-records))
          created         (:entity/created session)
          expiry-ts       (date-util/goog-add-days (date-util/js-date->goog-date-time created)
                                                   property-model/property-gis-import-session-max-age-days)]
      [:div.cloudpermit-page
       [ui/page-header (util/mmap match)
        [:h1 (str (tr [:property-gis-import/update-session-heading])
                  ": "
                  (-> session :property-import-session/municipality (municipality-model/municipality-name lang)))]]
       [:section.p-8
        [:div.mb-4
         [gis-import-common/jobs-table (util/mmap async-jobs tr)]]
        [:div.mb-4
         [ui/help
          (tr [:property-gis-import/update-attribute-guide]
              [(tr [:property/id])
               (tr [:property/integration-id])])]
         (when (and created (> (date-util/period (date-util/now) created :days) 1))
           [ui/warning
            (tr [:property-gis-import/expiry-warning]
                [(format-date expiry-ts)])])
         [:div.flex.w-full.justify-end.gap-4
          [ui/modal-confirmation-button
           {:id                  "remove-session-button"
            :tr                  tr
            :trigger-button-text (tr [:property-gis-import/remove-update-session])
            :trigger-button-opts {:kind :danger
                                  :size :field}
            :on-yes-click        #(>evt [::gis-import-common/remove-import-session
                                         session-id
                                         :property-gis-import/update-session-removed])}
           (tr [:property-gis-import/remove-update-session-confirm])]
          [ui/button
           {:kind     :secondary
            :size     :field
            :disabled (empty? (<sub [::gis-import-common/gis-mapping]))
            :on-click #(>evt [::gis-import-common/set-mapping-modal-open? true])}
           (tr [:property-gis-import/show-gis-mapping])]
          [ui/button
           {:kind     :primary
            :size     :field
            :disabled start-disabled?
            :on-click #(>evt [(if (or (ff/enabled? :feature-flag.id/property-data-integrity-tooling)
                                      (= "US-WA059" ; Skamania County
                                         (-> session :entity/parent :group/id)))
                                ::start-property-update
                                ::start-property-attribute-update)
                              session-id])}
           (tr [:property-gis-import/start-attribute-update])
           (when job-running?
             [:span.ml-4 (cc/inline-loading {:class-name "min-h-0"})])]]]
        [gis-import-common/temp-records-table (util/mmap temp-records tr)]]
       [gis-import-common/gis-mapping-section tr]])))


(def route
  {:name        :view/property-gis-update-session
   :view-sub    [::view-data]
   :view        view
   :parameters  {:path {:session-id s/Int}}
   :controllers [{:parameters {:path [:session-id]}
                  :start      (fn [{{:keys [session-id]} :path}]
                                (>evt [::gis-import-common/init session-id]))
                  :stop       (fn [{{:keys [session-id]} :path}]
                                (>evt [::property-dashboard-subs/remove-import-session-data session-id])
                                (>evt [::gis-import-common/clear]))}]})
